export class MovieSearchTitle
{

	constructor(id)
	{
		if (!!id) {
			this.id = id
			this.open = false
			this.$searchBlock = $(`#${this.id}`)
			this.$input = this.$searchBlock.find('.js-mst-input')
			this.$result = this.$searchBlock.find('.js-mst-result')
			this.allResultsUrl = '/search/index.php?q='

			this.settings = {
				minQueryLength: 3,
				searchDelay: 500,
			}

			this.init()
		} else {
			console.error('No id in construktor')
			return null
		}
	}

	init()
	{
		this.initHandlers()
	}

	initHandlers()
	{
		$(document).on('click', '.js-search-toggle', (e) => {
			e.stopPropagation()
			this.toggleBlockOpen()
		})

		$(document).on('keyup', (e) => {
			if (e.key === 'Escape' && this.isOpen() === true) {
				this.toggleBlockOpen()
			}
		})

		$(document).on('click', (e) => {
			if (
				this.isOpen() === true
				&& !this.$searchBlock.is(e.target)
				&& this.$searchBlock.has(e.target).length === 0
			) {
				this.toggleBlockOpen()
			}
		})

		this.$input.on('keyup', (e) => {
			if (this.$input.val().length < this.settings.minQueryLength) {
				return;
			}

			clearTimeout(this.inputTimeout)
			this.inputTimeout = setTimeout(() => {
				this.search()
			}, this.settings.searchDelay)
		})
	}

	async search()
	{
		try {
			let query = this.$input.val(),
				data = {
					query
				}

			this.lockResult()
			const result = await this.query('search', data)
			this.lockResult()

			if (result.data.success === true) {
				this.insertData(result.data.data)
			}

			if (result.data.success === false) {
				console.error(result.message)
			}

		} catch (e) {
			if (e.errors) {
				e.errors.forEach((error) => console.error(error.message))
			}
		}
	}

	insertData(data)
	{
		let html = ''

		this.resultClear()

		if (!!data.MODELS) {
			html = this.getDataModelsHtml(data.MODELS)
			this.resultApped(html)
		}
		if (!!data.IBLOCKS) {
			html = this.getDataIblocksHtml(data.IBLOCKS)
			this.resultApped(html)
		}

		if (!data.MODELS && !data.IBLOCKS) {
			this.resultApped(`<div class="py-25 text-center">Результатов не найдено</div>`)
		} else {
			this.resultApped(this.getButtonAllResultsHtml())
		}

		this.toggleResultOpen()
	}

	getDataModelsHtml(models)
	{
		var sections = '',
			html = ''

		for (let key in models) {
			let model = models[key]
			html = ''
			html += this.getSectionNameHtml(model.NAME)
			for (let key in model.ITEMS) {
				let item = model.ITEMS[key]
				let itemHtml = this.getResultItemHtml(
					item.PICTURE_SRC,
					`${item.TITLE}<span class="label label--xs align-middle label--${item.AGE} ml-5">${item.AGE}+</span>`,
					item.BODY_FORMATED,
					item.URL
				)
				html += itemHtml
			}
			
			sections += this.getSectionHtml(html)
		}

		return sections
	}

	getDataIblocksHtml(blocks)
	{
		var sections = '',
			html = ''

		for (let key in blocks) {
			let block = blocks[key]
			html = ''
			html += this.getSectionNameHtml(block.NAME)
			for (let key in block.ITEMS) {
				let item = block.ITEMS[key]
				let itemHtml = this.getResultItemHtml(
					item.PICTURE_SRC,
					item.TITLE,
					item.BODY_FORMATED,
					item.URL
				)
				html += itemHtml
			}
			
			sections += this.getSectionHtml(html)
		}

		return sections
	}

	getSectionHtml(sectionInnerHtml)
	{
		let html = `<div class="search-form__section">${sectionInnerHtml}</div>`

		return html
	}

	getSectionNameHtml(name)
	{
		let sectionName = `<div class="p-xs">${name}</div>`

		return sectionName;
	}

	getResultItemHtml(imageSrc, name, description, link)
	{
		let img = '',
			imgDevider = ''
		if (!!imageSrc) {
			img = `<img class="search-form__img" src="${imageSrc}" alt="">`
			imgDevider = 'pl-15'
		}
		
		let item = `<a class="search-form__link d-flex no-gutters align-items-start py-10" href="${link}">
			${img}
			<div class="${imgDevider}">
				<div class="search-form__name p-md font-weight-bold">${name}</div>
				<div class="search-form__description p-xs">${description}</div>
			</div>
		</a>`

		return item;
	}

	getButtonAllResultsHtml()
	{
		return `<div class="text-center py-25">
			<a class="btn btn-primary btn-primary--light px-30" href="${this.allResultsUrl}${this.$input.val()}">Все результаты поиска</a>
		</div>`
	}

	resultApped(html)
	{
		this.$result.append(html)
	}

	resultClear()
	{
		this.$result.html('')
	}

	query(action, data)
	{
		return new Promise((resolve, reject) => {
			BX.ajax.runComponentAction(
				'vlkino:movie.search.title',
				action,
				{
					mode: 'class',
					data: data,
				}
			).then(resolve, reject)
		})
	}

	toggleBlockOpen()
	{
		if (this.isOpen() === false) {
			this.open = true
			this.$searchBlock.addClass('is-show')
		} else {
			this.open = false
			this.$searchBlock.removeClass('is-show')
		}
	}

	toggleResultOpen()
	{
		this.$result.addClass('is-show')
	}

	isOpen()
	{
		return this.open
	}

	lockResult() {
		// this.$result.vlkinoLock()
	}

}
